export enum ActionType {
  CLEAR_SELECTED_AUDIO = 'app/sample-audio/CLEAR_SELECTED_AUDIO',

  SAMPLE_AUDIO_DOWNLOAD_REQUEST = 'app/sample-audio/SAMPLE_AUDIO_DOWNLOAD_REQUEST',
  SAMPLE_AUDIO_DOWNLOAD_SUCCESS = 'app/sample-audio/SAMPLE_AUDIO_DOWNLOAD_SUCCESS',
  SAMPLE_AUDIO_DOWNLOAD_FAILURE = 'app/sample-audio/SAMPLE_AUDIO_DOWNLOAD_FAILURE',
}
